import { render, staticRenderFns } from "./course-select.vue?vue&type=template&id=b9ac259e&"
import script from "./course-select.vue?vue&type=script&lang=js&"
export * from "./course-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports